import React from 'react';

import Logo from '../../../assets/rs_school_js.svg';

export default function Footer() {
  return (
    <footer className="footer bg-dark">
      <div className="footer__container">
        <div className="author">Irina Kovalenko, 2020</div>
        <div className="github"><a href="https://github.com/kovalenkoiryna15" className="github_link">GitHub</a></div>
        <a href="https://rs.school/js/" className="rss_logo"><img src={Logo} alt="Logo" className="rss_logo__img" /></a>
      </div>
    </footer>
  );
}
